import { ReactNode } from 'react';
import { useFlexCol } from '../hooks/useFlexCol';

type FlexColProps = {
	children: ReactNode;
};

const verticalOpt = {
	top: '',
	middle: 'justify-center',
	bottom: 'justify-end',
};

export function FlexCol({ children }: FlexColProps) {
	const {
		marginLeft,
		marginRight,
		paddingRight,
		paddingLeft,
		border,
		borderWidth,
		borderColor,
		blockClass,
		verticalAlign = 'top',
		horizontalAlign,
		componentId,
	} = useFlexCol();

	function parseHorizontalAlign() {
		if (horizontalAlign == 'center') return 'items-center';
		if (horizontalAlign == 'right') return 'items-end';
		return ' ';
	}
	function renderTokens() {
		const ml = `ml${marginLeft || 0}`;
		const mr = `mr${marginRight || 0}`;
		const pl = `pl${paddingLeft || 0}`;
		const pr = `pr${paddingRight || 0}`;
		const bw = `${borderWidth ? `bw${borderWidth}` : ''}`;
		const bc = `${borderColor ? `b--${borderColor}` : ''}`;
		const ha = parseHorizontalAlign();
		let b = '';

		if (typeof border === 'string') {
			b += `b${border.charAt(0).toLowerCase()}`;
		} else {
			if (border) b += border.map((b) => `b${b.charAt(0).toLowerCase()}`).join(' ');
		}

		return `${ml} ${mr} ${pl} ${pr} ${b} ${bw} ${bc} ${ha} flex flex-column ${verticalOpt[verticalAlign]}`;
	}

	function renderClass() {
		return blockClass && `vtex-flex-layout-0-x-flexCol--${blockClass} flexCol--${blockClass}`;
	}

	return (
		<div
			data-selection={componentId}
			className={`vtex-flex-layout-0-x-flexCol flexCol ${renderClass()} ${renderTokens()} h-100 w-100`}
		>
			{children}
		</div>
	);
}
